import reqest from "../common/reqest";

/**
 * 直播间分类
 * @param data
 * @returns {Promise<unknown>}
 */
export function getBroadcastClass(data) {
    return reqest.send("/Pub/Broadcast_Class",data,true)
  }
/**
 * 直播间岗位
 * @param data
 * @returns {Promise<unknown>}
 */
export function findUserJogList(data) {
  return reqest.send("/index/findUserJogList",data,true)
}
/**
 * 查询岗位/求职意向
 * @param data
 * @returns {Promise<unknown>}
 */
export function findJogList(data) {
  return reqest.send("/index/findJogList",data,true)
}
/**
 * 直播间列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getBroadcastList(data) {
  return reqest.send("/BroadcastBbs/Broadcast_List",data)
}
/**
 * 体验直播间列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function BroadcastExperienceList(data) {
  return reqest.send("/BroadcastBbs/Broadcast_experience_List ",data)
}
/**
 * 体验直播间列表(新接口)
 * @param data
 * @returns {Promise<unknown>}
 */
export function GetBroadcastExperienceList(data) {
  return reqest.send("/BroadcastBbs/Get_Broadcast_experience_List ",data)
}

/**
 * 修改直播间论坛
 * @param data
 * @returns {Promise<unknown>}
 */
export function editBroadcastList(data) {
  return reqest.send("/BroadcastBbs/Edit_Bbs",data)
}

/**
 * 观展记录
 * @param data
 * @returns {Promise<unknown>}
 */
export function  exhibitionRecord(data) {
  return reqest.send("/LiveOperation/Gz_Record",data)
}

/**
 * 参展记录
 * @param data
 * @returns {Promise<unknown>}
 */
export function  attendanceRecord(data) {
  return reqest.send("/LiveOperation/Cz_Record",data)
}

/**
 * 修改密码
 * @param data
 * @returns {Promise<unknown>}
 */
export function  editPassword(data) {
  return reqest.send("/Login/Edit_Pass",data)
}

/**
 * 创建论坛
 * @param data
 * @returns {Promise<unknown>}
 */
export function creatBbs(data) {
  return reqest.send("/BroadcastBbs/Create_Bbs",data)
}

 
/**
 * 直播间角色验证
 * @param data
 * @returns {Promise<unknown>}
 */
export function checkUser(data) {
  return reqest.send("/Live/Check_User", data)
}

/**
 * 直播间预约
 * @param data
 * @returns {Promise<unknown>}
 */
export function subscribe(data) {
  return reqest.send("/LiveOperation/subscribe", data)
}

/**
 * 直播间取消预约
 * @param data
 * @returns {Promise<unknown>}
 */
export function subscribeCancel(data) {
  return reqest.send("/LiveOperation/subscribe_cancel", data)
}


/**
 * -参展直播间预约列表
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function SubscribeCz(data) {
  return reqest.send("/LiveOperation/Subscribe_List_Cz", data)
}

/**
 * 观展直播间预约列表
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function SubscribeGz(data) {
  return reqest.send("/LiveOperation/Subscribe_List_Gz", data)
}

/**
 * 论坛数据统计
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function BbsCountTotal(data) {
  return reqest.send("/BroadcastBbs/Bbs_Count_Total", data)
}


/**
 * 获取邀请码
 * @param data
 * @returns {Promise<unknown>}
 */
export function showImg(data) {
  return reqest.send("/MakeQr/getExhibitionRr",data)
}


/**
 * 开启关闭直播间
 * @param data
 * @returns {Promise<unknown>}
 */
export function toggleBroadcast(data) {
  return reqest.send("/Pub/toggleBroadcast",data,true)
}
/**
 * 获取我的参展展会
 * @param data
 * @returns {Promise<unknown>}
 */
export function getMyExhibition(data) {
  return reqest.send("/Exhibition/get_my_exhibition",data)
}

/**
 * 获取我的参展展会直播间
 * @param data
 * @returns {Promise<unknown>}
 */
export function getMyBroadcastList(data) {
  return reqest.send("/Exhibition/get_my_broadcast_list",data)
}
